<div class="cards">
  <div class="card1" *ngFor="let poi of pois">
    <a routerLink="/{{getUrl(poi)}}">
      <img *ngIf="poi.images != null" src="{{poi.images.split(',')[0].replace('/images/', '/images/thumb-300w/')}}" width="175" height="200" alt="Bild {{poi.name}}">
      <img *ngIf="poi.images == null" src="/assets/placeholder.png" width="175" height="200" alt="placeholder">
      <div class="card-body">
        <h5 class="card-title">{{ poi.name }}</h5>
        <p class="description">Gemeinde {{ poi.municipality }}</p>
        <div class="stars">
          <div *ngFor="let num of [0,1,2,3,4]">
            <img src="/assets/star_yellow.png" height="164" width="164" alt="yellow star" *ngIf="poi.rating - num >= 1">
            <img src="/assets/star_half.png" height="164" width="164" alt="half yellow star" *ngIf="poi.rating - num < 1 && poi.rating - num >= 0.5">
            <img src="/assets/star_white.png" height="164" width="164" alt="gray yellow star" *ngIf="poi.rating - num <= 0">
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
